import { createSelector } from 'reselect'

const getSubjects = (state, curriculumID) => {
  const response = []
  const curSubjects = state.curriculum.getIn(['items', curriculumID])
  if (!curSubjects) {
    return null
  }

  // loop through curSubjects
  if (curSubjects.get('data')) {
    curSubjects.get('data').map((semSubject) =>
    semSubject.get('subjects').map((subject) => response.push(subject.toJS()))
  )
  }

  // sort subjects by code
  response.sort((a, b) => {
    if (a.code > b.code) {
      return 1
    }
    if (a.code < b.code) {
      return -1
    }
    // a must be equal to b
    return 0
  })

  return response
}

// convert subjects to options to be consumed by Select
export const makeGetSubjectOptions = () => createSelector(
  [getSubjects],
  (subjects) => {
    if (!subjects) {
      return null
    }
    return subjects.map((subject) => ({
      value: subject.id,
      label: subject.code + ' - ' + subject.name,
    }))
  }
)



// WEBPACK FOOTER //
// ./src/containers/Manage/Curriculums/selectors.js